import { base64Decode, base64Encode, isBase64 } from '../utils/base64';
import { Book } from './Book';
import { Content } from './Content';
import { CourseSection } from './CourseSection';
import { Edition } from './Edition';
import { Enrollment } from './Enrollment';
import { FlashcardDeck } from './FlashcardDeck';
import { FlashcardFeedback } from './FlashcardFeedback';
import { Item } from './Item';
import { Person } from './Person';
import { Product } from './Product';
import { Publisher } from './Publisher';
import { School } from './School';
import { Term } from './Term';

interface FlashcardImage {
  src: string;
  alt?: string;
  width?: string;
  height?: string;
}

export interface Flashcard extends Item {
  deckId: number;
  deck?: FlashcardDeck;

  publisherId?: number;
  publisher?: Publisher;

  bookId?: number;
  book?: Book;

  editionId?: number;
  edition?: Edition;

  contentId?: number;
  content?: Content;

  schoolId?: number;
  school?: School;

  termId?: number;
  term?: Term;

  courseSectionId?: number;
  courseSection?: CourseSection;

  personId?: number;
  person?: Person;

  enrollmentId?: number;
  enrollment?: Enrollment;

  productId?: number;
  product?: Product;

  chapterId?: string;
  pageId?: string;
  document?: string;
  anchorId?: string;
  anchorOffset?: number;
  anchorTextIndex?: number;
  focusTextIndex?: number;

  front: string;
  back: string;

  attemptId?: number;
  feedbacks?: FlashcardFeedback[];
  image?: FlashcardImage;
}

export const translateFlashcardFromTransport = (attributes: any) => {
  const { front, back } = attributes;
  return {
    ...attributes,
    front: isBase64(front) ? base64Decode(front) : front,
    back: isBase64(back) ? base64Decode(back) : back,
  };
};

export const translateFlashcardForTransport = (attributes: any) => {
  const { front, back } = attributes;

  return {
    ...attributes,
    front: base64Encode(front),
    back: base64Encode(back),
  };
};
